import React from 'react';
import { Box, Typography } from '@mui/material';

const Logo = ({ size = 40, fontSize = '1.2rem' }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 2
            }}
        >
            <Box
                sx={{
                    width: size,
                    height: size,
                    backgroundColor: '#2563eb', // blue-600
                    borderRadius: 3, // xl
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                }}
            >
                <span style={{ fontSize: typeof size === 'number' ? size * 0.6 : '1.5rem', lineHeight: 1 }}>🏫</span>
            </Box>
            <Typography
                variant="h6"
                component="div"
                sx={{
                    fontWeight: 700,
                    color: '#111827', // gray-900
                    fontSize: fontSize,
                    display: { xs: 'none', sm: 'block' }
                }}
            >
                Sherborne AI Portal
            </Typography>
        </Box>
    );
};

export default Logo;
